export default "__VITE_PUBLIC_ASSET__6fd91350__"